export default function normalizeSkill(skill) {
    return skill.toLowerCase().trim().replace(/\s+/g, " ");
}
